import { ref, computed } from 'vue';

export function useFilters(values: {
  weights?: number[];
  roofs?: string[];
  cabins?: string[];
  drivetrains?: string[];
  batteryCapacities?: number[];
  engines?: string[];
}) {
  const weights = ref(values.weights ?? []);
  const roofs = ref(values.roofs ?? []);
  const cabins = ref(values.cabins ?? []);
  const drivetrains = ref(values.drivetrains ?? []);
  const batteryCapacities = ref(values.batteryCapacities ?? []);
  const engines = ref(values.engines ?? []);

  const validOptions = computed(() => ({
    weights: weights.value.length > 1 ? weights.value : null,
    roofs: roofs.value.length > 1 ? roofs.value : null,
    cabins: cabins.value.length > 1 ? cabins.value : null,
    drivetrains: drivetrains.value.length > 1 ? drivetrains.value : null,
    batteryCapacities:
      batteryCapacities.value.length > 1 ? batteryCapacities.value : null,
    engines: engines.value.length > 1 ? engines.value : null,
  }));

  return {
    validOptions,
  };
}
